module.exports = __webpack_public_path__ + "img/m18.1cb6214.jpg";